/* eslint-disable import/no-unresolved */
import React from 'react';

import enterpriseSVG from 'assets/resources/icon/enterprise.svg';
import b2cv1SVG from 'assets/resources/icon/b2c_v1.svg';
import b2cv2SVG from 'assets/resources/icon/b2c_v2.svg';
import Layout from '../../components/Layout';

import PartialsHeader from '../../components/Partials/PartialsHeader';
import PartialsQuestion from '../../components/Partials/PartialsQuestion';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import IndustriesScrum from '../../components/Industries/IndustriesScrum';
import IndustriesCTA from '../../components/Industries/IndustriesCTA';
import IndustriesSingleItem from '../../components/Industries/IndustriesSingleItem';

const BUSINESS_LIST = [
  {
    icon: enterpriseSVG,
    title: 'Enterprise and industry systems',
    list: [
      'CRM Customer Relations Management',
      'ERP Enterprise Resource Planning',
      'OSS and BSS'
    ]
  },
  {
    icon: b2cv1SVG,
    title: 'B2C portals and websites',
    list: ['Customer management', 'Order processing', 'Secure payments']
  },
  {
    icon: b2cv2SVG,
    title: 'B2B portals and websites',
    list: ['Marketplace', 'Reporting tool', 'Work and document management']
  }
];

const Industry = () => {
  return (
    <Layout
      title="Blockchain Development across industries | Ulam Labs"
      description="Build a realiable product. We are a polish software development company that specializes in Python and blockchain technology."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Other Industries</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="telecommunication text-format">
        <IndustriesCTA
          extra="To win with competitors you need to have the best product with all processes running smoothly. At Ulam Labs, we are a seasoned team that  understand the dynamics an enterprise needs from across business sectors. Check how we can help you build your competitive advantage."
          title=""
        />
        <div className="container">
          <div className="softwares">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-md-auto">
                <div className="subtitle bigger without">
                  Software that serves your needs
                  <div className="extra">
                    We turn your ideas into software. Whether you need a B2C
                    site or B2B reporting tools and document management, our
                    team can provide top-notch products that you control. See
                    the examples of scope with which we can support you.
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="left-beam">
                  <div className="icon-beam horizontal">
                    <div className="row">
                      {BUSINESS_LIST.map(item => (
                        <IndustriesSingleItem item={item} key={item.title} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <IndustriesScrum />
            </div>
          </div>
        </div>
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          ignoredCategories={['Telco', 'Blockchain']}
        />
      </div>
      <PartialsQuestion />
    </Layout>
  );
};

export default Industry;
